import React, { Component, PropTypes } from 'react';
import bus from 'modules/npm-component/bus';
import { Resource } from '../../containers';

class App extends Component {
  static defaultProps = {
    items: null,
    serverRoute: null
  };

  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        className: PropTypes.string,
        title: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired
      })
    ),
    serverRoute: PropTypes.string
  };

  state = {
    clientRoute: null
  };

  componentDidMount() {
    bus.on('resources-page-route:home', () => this.setState({ clientRoute: 'home' }));
    bus.on('resources-page-route:whitepapers', () => this.setState({ clientRoute: 'whitepapers' }));
    bus.on('resources-page-route:webinars', () => this.setState({ clientRoute: 'webinars' }));
    bus.on('resources-page-route:ebooks', () => this.setState({ clientRoute: 'ebooks' }));
    bus.on('resources-page-route:videos', () => this.setState({ clientRoute: 'videos' }));
  }

  componentWillUnmount() {
    bus.off('resources-page-route:home');
    bus.off('resources-page-route:whitepapers');
    bus.off('resources-page-route:webinars');
    bus.off('resources-page-route:ebooks');
    bus.off('resources-page-route:videos');
  }

  render() {
    const { clientRoute } = this.state;
    const { serverRoute, items } = this.props;
    return <Resource items={items} route={clientRoute || serverRoute} />;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/resources/containers/App/App.js